import { render, staticRenderFns } from "./QfVideo.vue?vue&type=template&id=06ac1535&scoped=true&"
import script from "./QfVideo.vue?vue&type=script&lang=js&"
export * from "./QfVideo.vue?vue&type=script&lang=js&"
import style0 from "./QfVideo.vue?vue&type=style&index=0&id=06ac1535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac1535",
  null
  
)

export default component.exports